import React from "react";
import { InputGroup } from "@sonder/ui/source/styled/fragments/InputGroup";
import { RoleFilters } from "team/components/RoleFilters";
import { SquadFilters } from "team/components/SquadFilters";

export const TeamFilters = () => {
  return (
    <InputGroup>
      <SquadFilters />
      <RoleFilters />
    </InputGroup>
  );
};
